<template>
  <div class="row">
    <div class="col-md-6" :style="userStyle">
      <video-player
        v-if="videoLoaded"
        v-bind:style="{ overflow: 'hidden', borderWidth: border.borderWidth + 'px', borderRadius: border.radius + 'px', borderColor: border.borderColor, borderStyle: border.borderStyle  }"
        class="vjs-matrix vjs-big-play-centered"
        :class="{ 'controlBg': !controlBg }"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        @ready="playerReadied"
      ></video-player>
      <br />
      <b-form @submit="onSubmit">
        <b-form-group label="Category:">
          <b-form-select v-model="form.category" class="mb-3">
          <b-form-select-option :value="null" disabled>Please select a category</b-form-select-option>
          <b-form-select-option v-for="category in categories" :key="category._id" :value="category._id">{{ category.name }}</b-form-select-option>
        </b-form-select> 
        </b-form-group>

        <b-form-group label="Internal name:">
          <b-form-input
            v-model="form.internal_name"
            type="text"
            required
            placeholder="Enter internal name"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="External name:">
          <b-form-input v-model="form.external_title" type="text" placeholder="Enter External name"></b-form-input>
        </b-form-group>
        <b-form-group label="Description:">
          <b-form-textarea v-model="form.description"></b-form-textarea>
        </b-form-group>

        <div>
          <div>
            <md-button class="md-raised md-primary" @click="preview()">Preview</md-button>
            <md-button class="md-raised md-primary" @click="showVideoURL = !showVideoURL">Video URL</md-button>
            <md-button class="md-raised md-primary" @click="showHtmlCode = !showHtmlCode">Html Code</md-button>
          </div>
          <md-field v-if="showHtmlCode">
            <label>Html Code</label>
            <md-textarea v-model="htmlCode" md-autogrow></md-textarea>
          </md-field>
          <md-field v-if="showVideoURL">
            <label>Video URL</label>
            <md-textarea v-model="videoURL" md-autogrow></md-textarea>
          </md-field>
        </div>
          <button type="submit" class="btn btn-primary btn-block">Save</button>
      </b-form>
    </div>
    <div class="col-md-4">
      <md-list>
        <md-list-item>
          <span class="md-list-item-text">Autoplay</span>
          <md-switch v-model="playerOptions.autoplay"></md-switch>
        </md-list-item>
        <md-divider class="md-inset"></md-divider>
        <md-list-item>
          <span class="md-list-item-text">Muted</span>
          <md-switch v-model="playerOptions.muted"></md-switch>
        </md-list-item>
        <md-divider class="md-inset"></md-divider>
        <md-list-item>
          <span class="md-list-item-text">Loop</span>
          <md-switch v-model="playerOptions.loop"></md-switch>
        </md-list-item>
        <md-divider class="md-inset"></md-divider>
        <md-list-item>
          <span class="md-list-item-text">Border</span>
          <b-input-group size="sm" append="px" style="width: 100px;">
            <b-form-input v-model="border.borderWidth" type="number" size="sm"></b-form-input>
          </b-input-group>
        </md-list-item>
        <md-divider class="md-inset"></md-divider>
        <md-list-item>
          <span class="md-list-item-text">Border type</span>
          <b-input-group
            label-cols-sm="2"
            label="Border style:"
            label-align-sm="center"
            label-for="borderStyle"
            label-size="sm"
            style="width: 100px;"
          >
            <b-form-select size="sm" v-model="border.borderStyle">
              <option value="solid" selected>solid</option>
              <option value="double">double</option>
              <option value="dotted">dotted</option>
              <option value="dashed">dashed</option>
              <option value="groove">groove</option>
              <option value="ridge">ridge</option>
              <option value="inset">inset</option>
              <option value="outset">outset</option>
            </b-form-select>
          </b-input-group>
        </md-list-item>
        <md-divider class="md-inset"></md-divider>
        <md-list-item v-if="videoLoaded">
          <span class="">Border color</span>
          <!-- <color-picker :color="border.borderColor" @changeColor="changeColor" /> -->
             <verte style="
            margin: auto;
            margin-bottom: 365px;" v-model="border.borderColor" @changeColor="changeColor" 
            picker="square" model="hex" menuPosition="bottom" ></verte>
        </md-list-item>
        <md-divider class="md-inset"></md-divider>
        <md-list-item>
          <span class="md-list-item-text">Radius</span>
          <b-input-group size="sm" append="px" style="width: 100px;">
            <b-form-input v-model="border.radius" type="number" size="sm"></b-form-input>
          </b-input-group>
        </md-list-item>
        <md-divider class="md-inset"></md-divider>
        <md-list-item>
          <span class="md-list-item-text">Show Thumbnail</span>
          <md-switch @change="onShowPosterChange" v-model="showPoster"></md-switch>
      </md-list-item>
        <md-list-item v-if="showPoster">
          <b-input-group size="sm" style="width: 200px;">
            <input accept="image/*" type="file" @change="posterChange" size="sm" />
          </b-input-group>
        </md-list-item>

        <md-divider class="md-inset"></md-divider>

      <md-list-item>
          <span class="md-list-item-text">Show watermark</span>
          <md-switch @change="onWatermarkChange" v-model="showWatermark"></md-switch>
      </md-list-item>
       <md-list style="margin-left: 50px;" v-if="showWatermark">
          <md-list-item>
             <span class="md-list-item-text">Watermark</span>
            <b-input-group size="sm" style="width: 200px;">
            <input accept="image/*" type="file" @change="watermarkUpload" size="sm" />
          </b-input-group>
          </md-list-item>
          <md-list-item>
          <span class="md-list-item-text">Position</span>
          <b-input-group
            label-cols-sm="2"
            label="Border style:"
            label-align-sm="center"
            label-for="borderStyle"
            label-size="sm"
            style="width: 200px;"
          >
            <b-form-select size="sm" v-model="watermarkPosition" @change="onWatermarkChange">
              <option value="top-left">top-left</option>
              <option value="top-right">top-right</option> 
              <option value="bottom-left">bottom-left</option> 
              <option value="bottom-right">bottom-right</option>
            </b-form-select>
          </b-input-group>
        </md-list-item>
        <md-list-item>
             <span class="md-list-item-text">Watermark URL</span>
            <b-input-group size="sm" style="width: 200px;">
            <input accept="image/*" type="text" v-model="watermarkUrl" @change="onWatermarkChange" size="sm" />
          </b-input-group>
          </md-list-item>
       </md-list>
     <md-divider class="md-inset"></md-divider>
        <md-list-item>
          <span class="md-list-item-text">Show player elements</span>
          <md-switch v-model="playerOptions.controls"></md-switch>
        </md-list-item>
        <md-list style="margin-left: 50px;" v-if="playerOptions.controls">
          <md-list-item>
            <span class="md-list-item-text">Control gradient</span>
            <md-switch v-model="controlBg"></md-switch>
          </md-list-item>
          <md-list-item>
            <span class="md-list-item-text">Process bar</span>
            <md-switch v-model="playerOptions.controlBar.progressControl"></md-switch>
          </md-list-item>
          <md-list-item>
            <span class="md-list-item-text">Start / Stop</span>
            <md-switch v-model="playerOptions.controlBar.playToggle"></md-switch>
          </md-list-item>
          <md-list-item>
            <span class="md-list-item-text">Playback Rates</span>
            <md-switch v-model="playerOptions.controlBar.playbackRateMenuButton"></md-switch>
          </md-list-item>
          <md-list-item>
            <span class="md-list-item-text">Sound</span>
            <md-switch v-model="playerOptions.controlBar.volumePanel"></md-switch>
          </md-list-item>
          <md-list-item>
            <span class="md-list-item-text">Fullscreen</span>
            <md-switch v-model="playerOptions.controlBar.fullscreenToggle"></md-switch>
          </md-list-item>
          <md-list-item>
            <span class="md-list-item-text">Show time</span>
            <md-switch v-model="playerOptions.controlBar.currentTimeDisplay"></md-switch>
          </md-list-item>
          <md-list-item>
            <span class="md-list-item-text">Show video title</span>
            <md-switch v-model="showTitle"></md-switch>
          </md-list-item>
              <md-divider class="md-inset"></md-divider>
        <md-list-item v-if="videoLoaded">
             <span class="">Elements color</span>
              <verte style="
            margin: auto;
            margin-bottom: 365px;" v-model="elementColor" :value="elementColor"
            picker="square" model="hex" menuPosition="bottom" ></verte>
        </md-list-item>
        </md-list>
      </md-list>
    </div>
  </div>
</template>

<script>
import Verte from 'verte';
import { mapState } from "vuex";
import { videojs, videoPlayer } from "vue-video-player";
import axios from "axios";

import watermark from "videojs-watermark";

videojs.registerPlugin("watermark", watermark);

export default {
  components: {
    Verte,
    videoPlayer
  },

  data: () => ({
    videoLoaded: false,
    elementColor: "#fff",
    // Poster
    showPoster: false,
    poster: "",

    // watermark
    showWatermark: false,
    watermark: require("@/assets/logo.png"),
    watermarkPosition: "bottom-left",
    watermarkUrl: undefined,

    showTitle: true,
    controlBg: true,
    // showTime: true,

    htmlCode: null,
    videoURL: null,
    videoId: null,
    showHtmlCode: false,
    showVideoURL: false,
    // border and radius
    border: {
      borderWidth: 0,
      borderColor: "#525252",
      borderStyle: "solid",
      radius: 0
    },

    form: {
      category: "",
      internal_name: "",
      external_title: "",
      description: ""
    },

    playerOptions: {
      aspectRatio: "16:9",
      autoplay: false,
      controls: true,
      muted: false,
      loop: false,
      language: "en",
      preload: "auto",
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [
        {
          type: "video/mp4",
          src: ""
        }
      ],
      poster: "",

      controlBar: {
        // Hide and show time
        currentTimeDisplay: true,
        // should be default values and not saved in db
        timeDivider: false,
        durationDisplay: false,
        remainingTimeDisplay: false,

        // FUll SCRENN button
        fullscreenToggle: true,

        // Video timeline
        progressControl: true,

        // audo control
        volumePanel: true,

        playToggle: true,

        playbackRateMenuButton: true
      }

      // poster: "/static/images/author.jpg"
    }
  }),
  mounted() {
    this.$store.dispatch("loadCategories");
  },
  async created() {
    await axios
      .get(`${process.env.VUE_APP_API_URL}/api/videos/${this.$route.params.id}`)
      .then(res => {
        this.playerOptions.sources[0].src = `${process.env.VUE_APP_API_URL}/api/videos/watch/${this.$route.params.id}`;
        this.htmlCode = `<iframe frameborder="0" allowfullscreen width="800" height="500" src="${process.env.VUE_APP_API_URL}/preview/reiframe/${res.data._id}"></iframe>`;
        this.videoURL = `${process.env.VUE_APP_API_URL}/preview/reiframe/${res.data._id}`;
        this.videoId = res.data._id;
        this.form.category = res.data.category;
        this.form.external_title = res.data.external_title;
        this.form.internal_name = res.data.internal_name;
        this.form.description = res.data.description;

        this.playerOptions.autoplay = res.data.autoplay;
        this.playerOptions.controls = res.data.controls;
        this.playerOptions.muted = res.data.muted;
        this.playerOptions.loop = res.data.loop;
        // Poster
        this.showPoster = res.data.showPoster;
        if(res.data.showPoster) {
          this.playerOptions.poster = `${process.env.VUE_APP_API_URL}/${res.data.poster}`;
        }
        this.poster = `${process.env.VUE_APP_API_URL}/${res.data.poster}`;

        this.border.borderWidth = res.data.borderWidth;
        this.border.borderColor = res.data.borderColor;
        this.border.borderStyle = res.data.borderStyle;
        this.border.radius = res.data.radius;
      
        this.playerOptions.controlBar.currentTimeDisplay =
          res.data.currentTimeDisplay;
        this.playerOptions.controlBar.fullscreenToggle =
          res.data.fullscreenToggle;
        this.playerOptions.controlBar.progressControl =
          res.data.progressControl;
        this.playerOptions.controlBar.volumePanel = res.data.volumePanel;
        this.playerOptions.controlBar.playToggle = res.data.playToggle;
        this.playerOptions.controlBar.playbackRateMenuButton =
          res.data.playbackRateMenuButton;

        (this.showTitle = res.data.showTitle),
          (this.controlBg = res.data.controlBg),
          (this.videoLoaded = true);

        // watermark
        this.showWatermark = res.data.showWatermark;
        this.watermark = `${process.env.VUE_APP_API_URL}/${res.data.watermark}`;
        this.watermarkPosition = res.data.watermarkPosition;
        this.watermarkUrl = res.data.watermarkUrl;
          this.elementColor = res.data.elementColor;
      });
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
    player() {
      return this.$refs.videoPlayer.player;
    },
      userStyle () {
        return {
          '--element-color': this.elementColor
        }
      }
  },

  methods: {
    onShowPosterChange() {
      if(this.showPoster) {
        this.playerOptions.poster = this.poster;
      }
      else {
        this.playerOptions.poster = ""
      }
    },
    posterChange(event) {
      // console.log(event.target.files);
      const file = event.target.files[0];
      this.playerOptions.poster = URL.createObjectURL(file);

      const formData = new FormData();
      formData.append("file", file, file.name);
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/api/videos/poster/${this.$route.params.id}`,
          formData
        )
        .then(res => {
          this.$swal.fire({
            position: "center",
            type: "success",
            title: "Poster has been updated.",
            showConfirmButton: false,
            timer: 1500
          });
          // console.log(res.data);
        })
        .catch(err => {
          // console.log(err);
          this.$swal.fire({
            position: "center",
            type: "error",
            title: "Something wen't wrong.",
            showConfirmButton: false,
            timer: 1500
          });
        });
    },

    watermarkUpload(event) {
      // console.log(event.target.files);
      const file = event.target.files[0];
      // this.watermark = URL.createObjectURL(file);

      const formData = new FormData();
      formData.append("file", file, file.name);
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/api/videos/watermark/${this.$route.params.id}`,
          formData
        )
        .then(res => {
          this.$swal.fire({
            position: "center",
            type: "success",
            title: "Watermark has been updated.",
            showConfirmButton: false,
            timer: 1500
          });
          this.watermark = `${process.env.VUE_APP_API_URL}/${res.data.watermark}`;
          this.onWatermarkChange()
        })
        .catch(err => {
          // console.log(err);
          this.$swal.fire({
            position: "center",
            type: "error",
            title: "Something wen't wrong.",
            showConfirmButton: false,
            timer: 1500
          });
        });
    },

    changeColor(color) {
      const {
        rgba: { r, g, b, a }
      } = color;
      this.border.borderColor = `rgba(${r}, ${g}, ${b}, ${a})`;
    },
    preview() {
      this.$router.push({ name: "preview", params: { id: this.videoId } });
    },
    onSubmit(evt) {
      evt.preventDefault();
      var data = {
        category: this.form.category,
        external_title: this.form.external_title,
        internal_name: this.form.internal_name,
        description: this.form.description,
        aspectRatio: this.playerOptions.aspectRatio,
        autoplay: this.playerOptions.autoplay,
        controls: this.playerOptions.controls,
        loop: this.playerOptions.loop,
        muted: this.playerOptions.muted,

        // border and radious
        borderWidth: this.border.borderWidth,
        borderColor: this.border.borderColor,
        borderStyle: this.border.borderStyle,
        radius: this.border.radius,

        // Poster
        showPoster: this.showPoster,

        // Player elements
        currentTimeDisplay: this.playerOptions.controlBar.currentTimeDisplay,
        fullscreenToggle: this.playerOptions.controlBar.fullscreenToggle,
        progressControl: this.playerOptions.controlBar.progressControl,
        volumePanel: this.playerOptions.controlBar.volumePanel,
        playToggle: this.playerOptions.controlBar.playToggle,
        playbackRateMenuButton: this.playerOptions.controlBar
          .playbackRateMenuButton,
        showTitle: this.showTitle,
        controlBg: this.controlBg,

        // watermark
        showWatermark : this.showWatermark,
        watermarkPosition :  this.watermarkPosition,
        watermarkUrl: this.watermarkUrl,
        elementColor: this.elementColor,
      };
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/api/videos/${this.$route.params.id}`,
          data
        )
        .then(() => {
          this.$swal.fire({
            position: "center",
            type: "success",
            title: "Your settings has been saved.",
            showConfirmButton: false,
            timer: 1500
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    onWatermarkChange() {
      // console.log(this.watermark)
      if(document.getElementsByClassName('vjs-watermark-content').length > 0) {
          document.getElementsByClassName('vjs-watermark-content')[0].remove()
      }       
      if(this.showWatermark) {
        this.player.watermark({
            position: this.watermarkPosition,
            fadeTime: null,
            url: this.watermarkUrl,
            image: this.watermark,
          })
      }
      
    },
    playerReadied(player) {
      // console.log('example 2 ready!', player)
      this.onWatermarkChange();
    }
  }
};
</script>

<style lang="scss">
.controlBg {
  .vjs-control-bar {
    background: none !important;
  }
}
.vjs-watermark-content {
  img {
    max-width: 60px; 
  }
}

.vjs-matrix .vjs-button > .vjs-icon-placeholder:before,
.vjs-matrix .vjs-playback-rate,
.vjs-matrix.video-js{
    color: var(--element-color);
}
/* Change the border of the big play button. */
.vjs-matrix .vjs-big-play-button {
  border-color: var(--element-color);
}

/* Change the color of various "bars". */
.vjs-matrix .vjs-volume-level,
.vjs-matrix .vjs-play-progress,
.vjs-matrix .vjs-slider-bar {
  background: var(--element-color);
}


</style>
